import { RestartAlt } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useClearRefinements, UseClearRefinementsProps } from 'react-instantsearch';

import { useSearchContext } from '../SearchContextProvider';

export const SearchClearRefinements = (props: UseClearRefinementsProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SearchDialog' });

  const { aiSearchIsEnabled } = useSearchContext();
  const { refine } = useClearRefinements(props);

  useEffect(() => {
    refine();
  }, [aiSearchIsEnabled, refine]);

  return (
    <Button onClick={refine} variant="text" endIcon={<RestartAlt />}>
      {t('filter.resetAll')}
    </Button>
  );
};
